import { translationSolutions_da } from "./translationSolutions.da";
import { defineBilingualTranslations } from "./translationTypes";
import { translationSolutions_en } from "./translationSolutions.en";

export const translationSolutions = defineBilingualTranslations({
  da: translationSolutions_da,
  en: translationSolutions_en,
});
